// packages/shared/api-client/endpoints/analytics.js
// Analytics dashboard API endpoints

import { baseApi } from "../baseApi";

/**
 * Analytics API endpoints
 * Provides analytics dashboard with aggregated metrics
 */
const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get analytics dashboard
    getAnalyticsDashboard: builder.query({
      query: (params = {}) => ({
        url: '/api/analytics/dashboard',
        params, // { startDate?, endDate? }
      }),
      providesTags: ['Analytics'],
    }),
  }),
});

// Export hooks for usage in components
export const useGetAnalyticsDashboardQuery = analyticsApi.useGetAnalyticsDashboardQuery;
